//Libs
import React from 'react';
import PropTypes from 'prop-types';
//Componentes material
import TableCell from '@material-ui/core/TableCell';
import Typography from '@material-ui/core/Typography';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core';
//Models
import AvaliacaoResposta from '../../models/AvaliacaoResposta';
//Estilos
import ResultadoStyle from '../../styles/ResultadoStyle';

/**
 * Renderiza as respostas do tipo texto
 * @param {Object} props
 * @param {Array<AvaliacaoResposta>} props.respostas Dados das respostas a sere exibidas
 * @param {Object} props.classes Classes CSS do componente
 */
function ResultadoQuestaoTexto({ respostas, classes }) {
    if (respostas.length === 0) return 'Nenhuma resposta foi encontrada';

    return (
        <TableRow>
            {
                respostas.map(resposta => (
                    <TableCell key={resposta.id} ><Typography className={classes.texto} >{resposta.resposta}</Typography></TableCell>
                ))
            }
        </TableRow>
    );
}

ResultadoQuestaoTexto.propTypes = {
    /** Dados das respostas a serem exibidas */
    respostas: PropTypes.arrayOf(PropTypes.instanceOf(AvaliacaoResposta)).isRequired,
    /** Estilos do componente */
    classes: PropTypes.object
};

export default withStyles(ResultadoStyle)(ResultadoQuestaoTexto);